<button [class]="classes" [style]="styles" style="font-size: 16px;">
    {{ BUTTON_STYLE_TYPE_TRANSLATIONS[button.styleType] | translate }}
</button>
